
(() => {
  const script = document.currentScript;
  const endAt = Date.parse('2026-11-01T00:00:00+01:00');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'bestdealer-bats-off-2026';
  let root, expiryTimer, idle, destroyed = false;
  const dismissed = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
  const allowed = () => !destroyed && Date.now() < endAt && !motion.matches && !dismissed() &&
    !/\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname) && !navigator.connection?.saveData;
  const hide = () => {
    destroyed = true;
    root?.remove();
    clearInterval(expiryTimer);
    clearTimeout(idle);
    motion.removeEventListener('change', onMotion);
    document.removeEventListener('visibilitychange', onVisibility);
  };
  const onMotion = () => { if (motion.matches) hide(); };
  const onVisibility = () => {
    if (Date.now() >= endAt) return hide();
    root?.classList.toggle('bd-bats--paused', document.hidden);
  };
  const svg = '<svg class="bd-bats__svg" viewBox="0 0 100 60" aria-hidden="true" focusable="false"><path class="bd-bats__wing bd-bats__wing--left" d="M49 29C35 11 17 8 2 5C11 17 12 27 12 38C23 28 30 31 34 43C40 35 44 36 49 46Z"/><path class="bd-bats__wing bd-bats__wing--right" d="M51 29C65 11 83 8 98 5C89 17 88 27 88 38C77 28 70 31 66 43C60 35 56 36 51 46Z"/><path d="M43 27L41 15L48 22L52 22L59 15L57 27Q63 43 50 53Q37 43 43 27Z"/></svg>';
  const start = () => {
    if (!allowed() || document.querySelector('[data-bd-bats]')) return;
    root = document.createElement('div');
    root.className = 'bd-bats';
    root.dataset.bdBats = '';
    root.classList.toggle('bd-bats--paused', document.hidden);
    const decorative = document.createElement('div');
    decorative.setAttribute('aria-hidden', 'true');
    ['18vh','38vh','68vh'].forEach((height, i) => {
      const bat = document.createElement('span');
      bat.className = 'bd-bats__flight';
      bat.style.setProperty('--height', height);
      bat.style.setProperty('--delay', (i * 3) + 's');
      bat.innerHTML = svg;
      decorative.appendChild(bat);
    });
    root.appendChild(decorative);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bd-bats__close';
    button.textContent = script.dataset.closeLabel;
    button.addEventListener('click', () => {
      try { sessionStorage.setItem(key,'1'); } catch {}
      hide();
    });
    root.appendChild(button);
    document.body.appendChild(root);
    motion.addEventListener('change', onMotion);
    document.addEventListener('visibilitychange', onVisibility);
    expiryTimer = setInterval(() => { if (Date.now() >= endAt) hide(); }, 30000);
  };
  const queue = () => { if (allowed()) idle = setTimeout(start, 1600); };
  if (document.readyState === 'complete') queue();
  else window.addEventListener('load', queue, {once:true});
})();
